// import React from "react";
import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { ContactUsProps } from "./types";
import {
    PropertyDefinition
} from "app/library/layout-builder";

export class ContactUsDefinitions extends CmsReactComponent<ContactUsProps> {

    static schemaName = "contact-us";

    static propertyDefinitions: PropertyDefinition[] = [];

}
